[
    {
        "userType": "administrator",
        "menu": [
            {
                "code": "policies",
                "value": "policies",
                "label": "Policies",
                "icon": "Policies"
            },
            {
                "code": "summary",
                "label": "Summary",
                "value": "summary"
            },
            {
                "code": "terms",
                "label": "Terms",
                "value": "terms"
            },
            {
                "code": "underwriterCoverageAdjustment",
                "label": "Underwriting",
                "value": "underwriterCoverageAdjustment"
            },
            {
                "code": "policy",
                "label": "Policy",
                "value": "policy"
            },
            {
                "code": "applicant",
                "label": "Insured",
                "value": "applicant"
            },
            {
                "code": "securemyoffer.insuranceApplicant",
                "label": "Insurance Applicant",
                "value": "securemyoffer.insuranceApplicant"
            },
            {
                "code": "securemyoffer.additionalSellers",
                "label": "Additional Sellers",
                "value": "securemyoffer.additionalSellers"
            },
            {
                "code": "securemyoffer.secureMyOffer",
                "label": "Secure My Offer",
                "value": "securemyoffer.secureMyOffer"
            },
            {
                "code": "payment",
                "label": "Payment",
                "value": "payment"
            },
            {
                "code": "documents",
                "label": "Documents",
                "value": "documents"
            },
            {
                "code": "notes",
                "label": "Notes",
                "value": "note"
            },
            {
                "code": "history",
                "label": "History",
                "value": "history"
            },
            {
                "code": "logs",
                "label": "API Logs",
                "value": "logs"
            },
            {
                "code": "testMode",
                "label": "Test Mode",
                "value": "testMode"
            }
        ]
    },
    {
        "userType": "broker",
        "menu": [
            {
                "code": "policies",
                "value": "policies",
                "label": "Policies",
                "icon": "Policies"
            },
            {
                "code": "summary",
                "label": "Summary",
                "value": "summary"
            },
            {
                "code": "terms",
                "label": "Terms",
                "value": "terms"
            },
            {
                "code": "policy",
                "label": "Policy",
                "value": "policy"
            },
            {
                "code": "applicant",
                "label": "Insured",
                "value": "applicant"
            },
            {
                "code": "securemyoffer.insuranceApplicant",
                "label": "Insurance Applicant",
                "value": "securemyoffer.insuranceApplicant"
            },
            {
                "code": "securemyoffer.additionalSellers",
                "label": "Additional Sellers",
                "value": "securemyoffer.additionalSellers"
            },
            {
                "code": "securemyoffer.secureMyOffer",
                "label": "Secure My Offer",
                "value": "securemyoffer.secureMyOffer"
            },
            {
                "code": "payment",
                "label": "Payment",
                "value": "payment"
            },
            {
                "code": "documents",
                "label": "Documents",
                "value": "documents"
            },
            {
                "code": "notes",
                "label": "Notes",
                "value": "note"
            },
            {
                "code": "history",
                "label": "History",
                "value": "history"
            },
            {
                "code": "logs",
                "label": "API Logs",
                "value": "logs"
            }
        ]
    },
    {
        "userType": "client",
        "menu": [
            {
                "code": "summary",
                "label": "Summary",
                "value": "summary"
            },
            {
                "code": "documents",
                "label": "Documents",
                "value": "documents"
            }
        ]
    }
]
